"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var POIWithColor = function POIWithColor(_ref) {
  var fill = _ref.fill,
      width = _ref.width,
      height = _ref.height,
      viewBox = _ref.viewBox,
      className = _ref.className;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: width,
    viewBox: viewBox,
    height: height,
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21.76,0H2.24a.56.56,0,0,0-.63.64V20.15a.56.56,0,0,0,.63.64H8.63l3.21,3.15a.24.24,0,0,0,.32,0l3.21-3.15h6.39a.56.56,0,0,0,.63-.64V.64A.56.56,0,0,0,21.76,0Z",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9,9a2.3,2.3,0,0,1-.75,1.85,3.23,3.23,0,0,1-2.15.64H5.45v2.66H3.86V6.66H6.25a3.17,3.17,0,0,1,2.07.58A2.12,2.12,0,0,1,9,9ZM5.45,10.18H6a1.78,1.78,0,0,0,1.1-.29,1,1,0,0,0,.36-.84,1.05,1.05,0,0,0-.3-.83,1.45,1.45,0,0,0-1-.26H5.45Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M17.05,10.4a4.05,4.05,0,0,1-.92,2.85,3.42,3.42,0,0,1-2.64,1,3.42,3.42,0,0,1-2.65-1,4.08,4.08,0,0,1-.92-2.86,4,4,0,0,1,.93-2.86,3.43,3.43,0,0,1,2.65-1,3.42,3.42,0,0,1,2.64,1A4.11,4.11,0,0,1,17.05,10.4Zm-5.46,0a3.14,3.14,0,0,0,.47,1.89,1.68,1.68,0,0,0,1.43.63q1.89,0,1.89-2.52c0-1.69-.62-2.53-1.88-2.53a1.68,1.68,0,0,0-1.43.63A3.15,3.15,0,0,0,11.59,10.4Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M18.5,14.14V6.66h1.58v7.48Z",
    fill: fill
  }));
};

POIWithColor.propTypes = {
  fill: _propTypes["default"].string,
  width: _propTypes["default"].string,
  height: _propTypes["default"].string,
  viewBox: _propTypes["default"].string,
  className: _propTypes["default"].string
};
POIWithColor.defaultProps = {
  fill: '#000',
  width: '18',
  height: '18',
  viewBox: '0 0 24 24',
  className: ''
};
var _default = POIWithColor;
exports["default"] = _default;